/* unplugin-vue-components disabled */import { ElCascader as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/cascader/style/css';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { region } from '@/api/apis';
import { watchEffect } from 'vue';
export default {
  __name: 'areaSelect',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emit = __emit;
    var prop = __props;
    var value = ref('');
    var options = ref([]);
    var props = {
      value: 'title',
      label: 'title',
      children: 'child'
    };
    region({
      tree: 1
    }).then(res => {
      if (res.code == 200) {
        options.value = res.data;
      }
    });
    watchEffect(() => {
      if (prop.modelValue && options.value) {
        var arr = prop.modelValue.split('/');
        value.value = arr && arr.length == 3 && arr[2];
      } else {
        value.value = '';
      }
    }, {
      immediate: true
    });
    var handleChange = val => {
      emit('update:modelValue', Object.values(val).join('/'));
    };
    return (_ctx, _cache) => {
      var _component_el_cascader = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_el_cascader, {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
        options: _unref(options),
        props: props,
        onChange: handleChange
      }, null, 8, ["modelValue", "options"]);
    };
  }
};